import request from "./request";

const Dashboard = {
  obterEstatisticasTotais: () => request.get(`/estatisticas/orcamentos/totais`),
  obterEstatisticasTotaisOrcamentosSituacao: () => request.get(`/estatisticas/orcamentos/situacoes`),
  obterEstatisticasTotaisOrcamentosMensal: () => request.get(`/estatisticas/orcamentos/mensal`)
};

export default Dashboard;



// WEBPACK FOOTER //
// ./src/services/dashboard.js